angular.module('impactx.ruleset').service("RuleUserService", [
    'dataGen',
    'ToastService',
    'BackService',
    'TranslationService',
    '$redirect',
    RuleUserService]);

function RuleUserService(dataGen, ToastService, BackService, TranslationService, $redirect) {
    var saveRuleUser = function (scope) {
        return dataGen.postAsForm(scope, {formData: scope.data}, "/ruleuser/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if (scope.refTable) {
                switch(scope.refTable) {
                    case "bud":
                        $redirect.redirectTo(null, "/budgetlist");
                        break;
                    case "csc":
                        $redirect.redirectTo(null, "/cscontractlist");
                        break;
                    default:
                        $redirect.redirectTo(null, "/" + scope.refTable + "list");
                        break;
                }
            } else {
                BackService.back();
            }
        });
    };

    var deleteRuleUser = function (scope) {
        return dataGen.postAsForm(scope, {ateId: scope.data.id}, '/ruleuser/delete').then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        });
    };

    var toggleRuleUserType = function (scope, ruleType) {
        if (ruleType) {
            scope.data.roles.selected = null;
            scope.data.responsibilities.selected = null;
            scope.data.users.selected = null;
        }
        angular.forEach(scope.data.ruleUserTypes, function (ruleUserType) {
            if (!ruleType || ruleType.identifier !== ruleUserType.primaryType.identifier) {
                ruleUserType.primaryType.value = false;
            }
            if (ruleUserType.secondaryType) {
                if (!ruleType || ruleType.identifier !== ruleUserType.secondaryType.identifier) {
                    ruleUserType.secondaryType.value = false;
                }
            }
        })
    };

    var hasNoSelectedApprover = function (scope) {
        if (scope.data && scope.data.atpId) {
            // Check the selected id (not value): the empty "---" role option has id 0
            // and must not count as a selected approver (IOBL-15359). !!0 === false,
            // while a real role/responsibility/user selection has id > 0.
            return !(!!impactX.isDefined(scope, 'data.roles.selected.id') ||
                !!impactX.isDefined(scope, 'data.responsibilities.selected.id') ||
                !!impactX.isDefined(scope, 'data.users.selected.id') ||
                hasRuleUserType(scope));
        }
        else {
            return true;
        }
    };

    var clearChangeType = function (scope, notificationEnabled, modificationEnabled) {
        scope.data.notificationEnabled.value = notificationEnabled;
        scope.data.modificationEnabled.value = modificationEnabled;
    };

    function hasRuleUserType(scope) {
        var result = false;
        angular.forEach(scope.data.ruleUserTypes, function (ruleUserType) {
            if (ruleUserType.primaryType.value || impactX.isDefined(ruleUserType, 'secondaryType.value')) {
                result = true;
            }
        });

        return result;
    }

    return {
        saveRuleUser: saveRuleUser,
        deleteRuleUser: deleteRuleUser,
        toggleRuleUserType: toggleRuleUserType,
        hasNoSelectedApprover: hasNoSelectedApprover,
        clearChangeType: clearChangeType
    };
}


